import React from 'react';
import ModalButton from '../UI/ModalButton';
import LanguageSwitcher from '../UI/LanguageSwitcher';
import { useLanguage } from '../../context/LanguageContext';

interface SuccessDialogProps {
  onBackToMerchant?: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({
  onBackToMerchant
}) => {
  const { t } = useLanguage();

  const CheckIcon = () => (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 28L22 38L44 16"
        stroke="#22C55E"
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="success-dialog">
      <div className="dialog-header">
        <LanguageSwitcher />
      </div>
      <div className="success-dialog__content-wrapper">
        <div className="success-dialog__icon">
          <div className="success-dialog__icon-inner">
            <CheckIcon />
          </div>
        </div>

        <div className="success-dialog__content">
          <h2 className="success-dialog__title">{t('success')}</h2>
          <p className="success-dialog__desc">{t('successDescription')}</p>
          <p className="success-dialog__hint">{t('successReturnHint')}</p>
        </div>
      </div>

      {onBackToMerchant && (
        <div className="success-dialog__actions">
          <ModalButton
            variant="primary"
            onClick={onBackToMerchant}
          >
            {t('backToMerchant')}
          </ModalButton>
        </div>
      )}
    </div>
  );
};

export default SuccessDialog;
